// extracted by mini-css-extract-plugin
export var actions = "_27-0";
export var actionsContainer = "_27-7";
export var border = "_27-1";
export var childFullHeight = "_27-f";
export var collapse = "_27-2";
export var content = "_27-a";
export var contentChild = "_27-e";
export var fullscreen = "_27-c";
export var hasLeftRadius = "_27-k";
export var headerContainer = "_27-3";
export var headerRow = "_27-5";
export var hidePadding = "_27-b";
export var navCollapsedGap = "_27-l";
export var noScrollX = "_27-m";
export var noScrollY = "_27-n";
export var noTopPadding = "_27-i";
export var optOutTopPadding = "_27-d";
export var pageMain = "_27-j";
export var pageOuter = "_27-g";
export var pagePadding = "_27-8";
export var pageScroll = "_27-9";
export var profile = "_27-o";
export var profileContainer = "_27-p";
export var profileImage = "_27-q";
export var profileMain = "_27-r";
export var profileSubtitle = "_27-t";
export var profileTitle = "_27-s";
export var showLeftPadding = "_27-h";
export var tabsPortalSlot = "_27-6";
export var tabsWrapper = "_27-4";
export var title = "_27-u";